import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { ScreenHardwareComponent } from '../../../../../pages/datasets/screen-hardware/screen-hardware.component';
import { ScreenHardwareEditComponent } from '../../../../../pages/datasets/screen-hardware-edit/screen-hardware-edit.component';

export const screenHardware: Route = {
  path: 'screen-hardware',
  title: 'nav.network.screenHardware',
  data: {
    breadcrumb: 'nav.network.screenHardware',
    icon: SbIcons.screenSetting,
    id: RoutingID.screenHardware,
  },
  children: [
    {
      path: '',
      component: ScreenHardwareComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'screen-hardware-edit/:screenHardwareID',
      title: 'nav.datasets.screenHardware.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.screenHardware.edit',
        id: RoutingID.screenHardwareEdit,
      },
      children: [
        {
          path: '',
          component: ScreenHardwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'screen-hardware-create',
      title: 'nav.datasets.device.software.create',
      data: {
        breadcrumb: 'nav.datasets.device.software.create',
        icon: SbIcons.plus,
        id: RoutingID.screenHardwareCreate,
      },
      children: [
        {
          path: '',
          component: ScreenHardwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
